import Input from 'components/input/input';
import Select from 'components/select/select';

import { TYPES, ACCOUNT_STATUSES, GENDER_OPTIONS } from 'config/doctor';
import { COUNTRIES } from 'config/country';
import PhoneNumber from 'components/phone_number/phone_number';

const ViewComponent = ({
  doctor,
  onChange,
  onSelect,
  onPhoneChange,
  validation,
}) => {
  return (
    <div className="pa5 pt8 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
      <div className="w-100 flex flex-column">
        <div className="w-100 flex flex-column items-start justify-between margin-between">
          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-50">
              <Input
                name="lastName"
                label="Last name*"
                value={doctor.lastName}
                valid={validation.lastName}
                onChange={onChange}
              />
            </div>
            <div className="w-50">
              <Input
                name="firstName"
                label="First name*"
                value={doctor.firstName}
                valid={validation.firstName}
                onChange={onChange}
              />
            </div>
          </div>
          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-50">
              <Select
                label="Account status*"
                value={doctor.isActive}
                valid={true}
                options={ACCOUNT_STATUSES}
                onChange={(selectedOption) =>
                  onSelect('isActive', selectedOption)
                }
              />
            </div>
            <div className="w-50">
              <Select
                className="type-select"
                valid={validation.type}
                isMulti={false}
                label="Account type*"
                value={doctor.type}
                options={TYPES}
                onChange={(selectedOption) => onSelect('type', selectedOption)}
              />
            </div>
          </div>
          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-50">
              <Select
                valid={validation.gender}
                label="Gender*"
                value={doctor.gender}
                options={GENDER_OPTIONS}
                onChange={(selectedOption) =>
                  onSelect('gender', selectedOption)
                }
              />
            </div>
            <div className="w-50">
              <Input
                name="email"
                label="Email*"
                value={doctor.email}
                valid={validation.email}
                validationText="Please enter a valid email"
                onChange={onChange}
              />
            </div>
          </div>
          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-50">
              <PhoneNumber
                name="phone"
                label="Phone number"
                value={doctor.phone}
                valid={validation.phone}
                onChange={onPhoneChange}
              />
            </div>
            <div className="w-50">
              <Input
                name="personalEmail"
                label="Personal email"
                value={doctor.personalEmail}
                valid={validation.personalEmail}
                validationText="Please enter a valid email"
                onChange={onChange}
              />
            </div>
          </div>
          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-50">
              <Select
                className="country-select"
                valid={true}
                isMulti={false}
                label="Country"
                value={doctor.country}
                options={COUNTRIES}
                onChange={(selectedOption) =>
                  onSelect('country', selectedOption)
                }
              />
            </div>
            <div className="w-50">
              <Input
                name="city"
                label="City"
                value={doctor.city}
                valid={true}
                onChange={onChange}
              />
            </div>
          </div>
          <div className="w-100 flex flex-row justify-between margin-between">
            <div className="w-33">
              <Input
                name="calendlyUrl"
                label="Calendly link"
                value={doctor.calendlyUrl}
                valid={true}
                onChange={onChange}
              />
            </div>
            <div className="w-33">
              <Input
                name="teleconsultationRoomUrl"
                label="Teleconsultation room link"
                value={doctor.teleconsultationRoomUrl}
                valid={true}
                onChange={onChange}
              />
            </div>
            <div className="w-33">
              <Input
                name="stripeUrl"
                label="Stripe link"
                value={doctor.stripeUrl}
                valid={true}
                onChange={onChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewComponent;
